import {Component, EventEmitter, OnInit, Output, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {dateValidator, phoneValidator} from '../../../../_utils/validators';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';
import {ADDRESS_PATTERN, EMPLOYER_PATTERN, FOUR_DIGITS_PATTERN} from '../../../../_constants/constants';
import {NgClass} from '@angular/common';
import {HideOnBlurDirective} from '../../../../_directives/hide-on-blur.directive';
import {NgxMaskModule} from 'ngx-mask';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-eaml-subject-form',
    templateUrl: '../aml-subject-form/aml-subject-form.component.html',
    styleUrls: ['../aml-subject-form/aml-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent, ReactiveFormsModule, NgClass, HideOnBlurDirective, NgxMaskModule, ValidationErrorsComponent_1, TranslateModule]
})
export class EamlSubjectFormComponent implements OnInit {

  @Output() submittedData: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  displayErrors: boolean = false;

  subjectFormGroup: UntypedFormGroup;
  identificationFormGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;
  private formBuilder = inject(UntypedFormBuilder);

  constructor() {
    const formBuilder = this.formBuilder;

    this.subjectFormGroup = StandardSubjectFormComponent.buildSubjectFormGroup(formBuilder, {
      firstName:       ['', Validators.compose([Validators.required, Validators.maxLength(20)])],
      middleName:      ['', Validators.maxLength(11)],
      lastName:        ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      inclPrevAddress: '',
      phone:           ['', Validators.compose([Validators.required, Validators.maxLength(10), phoneValidator])],
      job:             ['', Validators.compose([Validators.maxLength(30), Validators.pattern(ADDRESS_PATTERN)])],
      employer:        ['', Validators.compose([Validators.maxLength(35), Validators.pattern(EMPLOYER_PATTERN)])]
    });
    this.identificationFormGroup = this.formBuilder.group({
      sin: ['', Validators.pattern(FOUR_DIGITS_PATTERN)],
      dob: ['', dateValidator]
    });
    this.addressFormGroup = StandardSubjectFormComponent.buildAddressFormGroup(this.formBuilder);
  }

  ngOnInit(): void {
  }

}
